import * as React from 'react'

interface CodeIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number
}

export const CodeIcon = ({ size = 24, ...props }: CodeIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <polyline points="16 18 22 12 16 6" />
    <polyline points="8 6 2 12 8 18" />
  </svg>
)
